import { toObject } from "../../core/utils";
import constants from "../../core/constants";

class BasicPlanPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (data) => {
      data.rate /= constants.currencyBy;

      return data;
    };

    return toObject(format(data));
  }
}

export default BasicPlanPageTransform;



// WEBPACK FOOTER //
// ./src/pages/basicPlan/basicPlan.transforms.js